export default function BlueprintSection() {
  return (
    <section className="relative py-28 md:py-36 overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-fixed"
        style={{
          backgroundImage: "url('/images/cta-background.webp')",
        }}
      />
      <div className="absolute inset-0 bg-charcoal-900/80"></div>
      <div
        className="absolute inset-0 opacity-[0.02]"
        style={{
          backgroundImage: 'repeating-linear-gradient(0deg, transparent, transparent 2px, rgba(255,255,255,0.5) 2px, rgba(255,255,255,0.5) 4px), repeating-linear-gradient(90deg, transparent, transparent 2px, rgba(255,255,255,0.5) 2px, rgba(255,255,255,0.5) 4px)',
        }}
      />

      <div className="relative z-10 max-w-[1600px] mx-auto px-6 md:px-12 lg:px-16">
        <div className="max-w-3xl">
          <p className="font-mono text-xs text-terracotta-400 tracking-[0.25em] uppercase mb-6 whitespace-nowrap">
            Integrated Delivery
          </p>

          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-cream-50 leading-tight mb-10">
            From the blueprint to the browser.
          </h2>

          <div className="w-16 h-[2px] bg-terracotta-500 mb-10"></div>

          <p className="text-lg md:text-xl text-stone-300 leading-relaxed font-light max-w-2xl">
            Many projects split design, marketing and digital delivery across separate suppliers. We connect them, so your drawings, brand and buyer experience move in the same direction.
          </p>
        </div>
      </div>

      <div className="absolute top-1/4 right-[8%] w-24 h-24 border border-cream-100/8 hidden lg:block animate-float-slower"></div>
    </section>
  );
}
